import React from 'react';
import PropTypes from 'prop-types';
import MutationWithProgress from 'react-apollo/MutationWithProgress';

import Styled from 'styled';
import ImageView from 'lib/images/image-view';

import ImageInput from 'four-nets/ui-v2/form/image-input/image-input';
import { ViewerConsumer } from 'four-nets/user/viewer/viewer';
import uploadPhotoFile, {
    UploadPhotoFilesMutation,
    UploadPhotoFilesMutationVariables,
} from 'four-nets/photofile/upload/upload.graphql';
import UploadProgress from 'four-nets/ui-v2/upload-progress/upload-progress';
import { PhotoFileFragment } from 'four-nets/photofile/photofile.graphql';

import defaultStyles from './image-upload.scss';

export interface Props {
    styles: typeof defaultStyles;
    key: number;
    onChange: (image: PhotoFileFragment | undefined) => void;
}

interface State {
    inputKey: number;
    progress: number;
    image?: PhotoFileFragment | File;
}

function isUploaded(value: any): value is PhotoFileFragment {
    return value instanceof Object && value.__typename === 'PhotoFileNode';
}

class ImageUpload extends React.PureComponent<Props, State> {
    state: State = { inputKey: 0, progress: 0 };
    setProgress?: (progress: number) => void;

    static contextTypes = {
        authCheck: PropTypes.func,
    };

    onProgress = (event: ProgressEvent) => {
        if (this.setProgress) {
            this.setProgress(event.loaded / event.total);
        }
    };

    render() {
        const { styles } = this.props;

        return (
            <MutationWithProgress<UploadPhotoFilesMutation, UploadPhotoFilesMutationVariables>
                mutation={uploadPhotoFile}
                onProgress={this.onProgress}
            >
                {upload => (
                    <ViewerConsumer>
                        {({ viewer }) => (
                            <React.Fragment>
                                <div className={styles.actions}>
                                    <ImageInput
                                        inputKey={this.state.inputKey + this.props.key}
                                        multiple={false}
                                        onClick={event => {
                                            if (!viewer) {
                                                event.preventDefault();
                                                this.context.authCheck();
                                            }
                                        }}
                                        onChange={event => {
                                            if (this.state.image) {
                                                // abort(values.image);
                                            }

                                            const file =
                                                event.target.files &&
                                                event.target.files.length &&
                                                event.target.files[0];

                                            if (file) {
                                                this.setState({ progress: 0, image: file }, () => {
                                                    this.setProgress = progress => {
                                                        if (file === this.state.image) {
                                                            this.setState({ progress });
                                                        }
                                                    };

                                                    upload({
                                                        variables: { input: { files: [file], photoFileType: 16 } },
                                                    }).then(result => {
                                                        const imageResult = result as {
                                                            data: UploadPhotoFilesMutation;
                                                        };
                                                        const photoFile =
                                                            imageResult &&
                                                            imageResult.data &&
                                                            imageResult.data.uploadPhotoFiles &&
                                                            imageResult.data.uploadPhotoFiles.photoFiles &&
                                                            imageResult.data.uploadPhotoFiles.photoFiles.length > 0 &&
                                                            imageResult.data.uploadPhotoFiles.photoFiles[0];

                                                        if (photoFile) {
                                                            this.setState({ image: photoFile }, () =>
                                                                this.props.onChange(photoFile)
                                                            );
                                                        }
                                                    });
                                                });
                                            }

                                            // this will force remount of input element, we want this,
                                            // because onChange event is not fired when user selects the same file
                                            this.setState(prevState => ({ inputKey: prevState.inputKey + 1 }));
                                        }}
                                    >
                                        {this.props.children}
                                    </ImageInput>
                                </div>
                                {this.state.image ? (
                                    <UploadProgress
                                        progress={this.state.progress}
                                        onClose={() => {
                                            if (this.state.image) {
                                                // abort(values.image);
                                            }
                                            this.setState({ image: undefined }, () => this.props.onChange(undefined));
                                        }}
                                    >
                                        {isUploaded(this.state.image) ? (
                                            <ImageView
                                                sizes={{ xs: 200 }}
                                                src={this.state.image.src}
                                                srcSet={this.state.image.srcset!}
                                                aspectFill={true}
                                            />
                                        ) : null}
                                    </UploadProgress>
                                ) : null}
                            </React.Fragment>
                        )}
                    </ViewerConsumer>
                )}
            </MutationWithProgress>
        );
    }
}

export default Styled(defaultStyles)(ImageUpload);
